// This dialog appears after the user has selected to load their wallet with cash
// it confirms their next steps and the total to bring including their transaction fee.
import React from "react";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import FormLabel from "@material-ui/core/FormLabel";
import Typography from "@material-ui/core/Typography"; // for Material-UI v4

export default function CashDialogConfirmation({
  open,
  amount,
  setLoadWalletOpen,
  onClose,
  balance,
  setBalance,
  communityLocation,
  placeOrderOnConfirm,
}) {
  // Checks to see if the user is using a communityLocation or a distributionLocation and checks what the
  // cash transaction fees are and then sets them.
  const distributionLocation = communityLocation.pickupLocation
    ? communityLocation.pickupLocation
    : { ...communityLocation };
  const cashTransactionFee = distributionLocation.cashTransactionFee ?? 0;
  // The amount to load onto the wallet with the default being the balance of the order.
  const amountTemp = parseFloat(amount) || 0;

  // If the user wants to go back and change the amount.
  const handleBack = () => {
    setLoadWalletOpen(true);
    onClose(false);
  };

  // When the user has confirmed the amount they are loading by cash.  When
  // they came here from the "Place Order" flow we also place the order
  // immediately so the order isn't left hanging after they confirm payment.
  const handleNext = () => {
    const balanceTemp = amountTemp + balance;
    setBalance(balanceTemp);
    onClose(false);
    if (typeof placeOrderOnConfirm === "function") {
      placeOrderOnConfirm();
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)}>
      <DialogTitle>Please Bring Payment on Order Pickup</DialogTitle>
      <DialogContent>
        {/* Payment Method */}
        <FormLabel component="legend">
          Loading Money onto Your Account
        </FormLabel>
        <Typography>
          Please bring{" "}
          <strong>${(amountTemp + cashTransactionFee).toFixed(2)}</strong> in
          cash when you pick up your order. This includes a{" "}
          <strong>${cashTransactionFee.toFixed(2)} transaction fee</strong>.
        </Typography>
        <Typography sx={{ mt: 2 }}>
          You will not be able to receive your order if you do not bring cash on
          pick up.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => handleBack()} color="secondary">
          BACK
        </Button>
        <Button
          onClick={() => handleNext()}
          color="primary"
          variant="contained"
        >
          {typeof placeOrderOnConfirm === "function"
            ? "I'LL BRING CASH — PLACE ORDER"
            : "NEXT"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
